import { Button } from '@chakra-ui/react';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { adjustHoverColor } from 'utils/color';
import { useWidget } from 'widgets/sdk';

import { DEFAULT_SUBMIT_BACKGROUND_COLOR, DEFAULT_SUBMIT_TEXT_COLOR } from '../MultipleChoicesWidget.config';
import { MultipleChoicesWidgetData } from '../MultipleChoicesWidget.types';

type SubmitButtonProps = {
  onSubmit: () => void;
};

export const SubmitButton = ({ onSubmit }: SubmitButtonProps) => {
  const { t } = useTranslation('multiple_choices_widget', {
    keyPrefix: 'viewMode',
    useSuspense: false,
  });

  const { submitTextColor = DEFAULT_SUBMIT_TEXT_COLOR, submitBackgroundColor = DEFAULT_SUBMIT_BACKGROUND_COLOR } =
    useWidget<MultipleChoicesWidgetData>();

  const hoverBgColor = useMemo(() => adjustHoverColor(submitBackgroundColor), [submitBackgroundColor]);

  return (
    <Button
      variant={'action'}
      borderRadius='50px'
      color={submitTextColor}
      bgColor={submitBackgroundColor}
      _hover={{ bgColor: hoverBgColor }}
      onClick={onSubmit}
    >
      {t('submit')}
    </Button>
  );
};
